import {
	Grid,
	Typography,
	IconButton as MaterialIconButton,
} from '@mui/material';
import { CircleClose, GreenTickIcon } from '../assets/icons/Icons';

function FileContentTile({ file, onRemoveFiles, disableCloseBtn = false }) {
	return (
		<Grid
			container
			flexDirection={'row'}
			bgcolor={'#EEF1F7'}
			borderRadius={'5px'}
			padding={'5px'}
			sx={{ boxShadow: 2 }}
			justifyContent={'space-between'}
			alignItems={'center'}
			marginRight={'10px'}>
			<Grid item width={'80%'} flexDirection={'column'}>
				<Typography
					style={{
						wordWrap: 'break-word',
					}}
					color={'#292D32'}
					fontSize={'14px'}
					title={file.name.length > 24 ? file.name : undefined}
					component="span">
					{file.name.length > 24
						? `${file.name.slice(0, 21)}...`
						: file.name}
				</Typography>
				<Grid container flexDirection={'row'} alignItems={'center'}>
					<Typography
						color={'#A9ACB4'}
						marginRight={'5px'}
						fontSize={'12px'}>
						{(file.size / 1024).toFixed(2)} KB •
					</Typography>
					<GreenTickIcon />
				</Grid>
			</Grid>
			<MaterialIconButton
				disableRipple
				disabled={disableCloseBtn}
				style={{ padding: '0' }}
				onClick={() => onRemoveFiles(file)}>
				<CircleClose />
			</MaterialIconButton>
		</Grid>
	);
}

export default FileContentTile;
